import { FormActions } from '@openx/components-core/lib/FormActions/FormActions';
import type { InventoryListFormState } from '@openx/types/inventoryList';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { DetailsSection } from './components/DetailsSection';
import { InventorySection } from './components/InventorySection';
import { OrganizationSection } from './components/OrganizationSection';

type InventoryListsFormFieldsProps = {
  isEdit: boolean;
  loading: boolean;
};

export const InventoryListsFormFields = ({ isEdit, loading }: InventoryListsFormFieldsProps) => {
  const { t } = useTranslation();
  const {
    formState: { isDirty, isSubmitting },
  } = useFormContext<InventoryListFormState>();
  const navigate = useNavigate();

  const disabledSubmit = isSubmitting || loading || (isEdit && !isDirty);

  return (
    <>
      <OrganizationSection isEdit={isEdit} />
      <DetailsSection />
      <InventorySection isEdit={isEdit} />

      <FormActions
        cancelButtonLabel={t('Cancel')}
        disabled={disabledSubmit}
        isSubmitting={isSubmitting || loading}
        onCancel={() => {
          navigate('/inventory-lists');
        }}
        submitButtonLabel={t('Save')}
      />
    </>
  );
};
